module.exports = __webpack_public_path__ + "static/img/jian.f7530bd3.svg";